import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "primeng/api";
import * as i2 from "@ngx-translate/core";
export class DialogV2Service {
  confirmationService;
  translateService;
  _dialogData = new Subject();
  _message = '';
  _DIALOG_KEY = 'dialog';
  constructor(confirmationService, translateService) {
    this.confirmationService = confirmationService;
    this.translateService = translateService;
  }
  open(data) {
    this._dialogData.next(data);
    this._message = this.translateService.instant(data.message);
    this.confirmationService.confirm({
      key: this._DIALOG_KEY,
      message: this._message
    });
  }
  close() {
    this.confirmationService.close();
  }
  get dialogData() {
    return this._dialogData.asObservable();
  }
  get key() {
    return this._DIALOG_KEY;
  }
  set message(message) {
    this._message = message;
  }
  static ɵfac = function DialogV2Service_Factory(t) {
    return new (t || DialogV2Service)(i0.ɵɵinject(i1.ConfirmationService), i0.ɵɵinject(i2.TranslateService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: DialogV2Service,
    factory: DialogV2Service.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DialogV2Service, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.ConfirmationService
  }, {
    type: i2.TranslateService
  }], null);
})();
